import { CuboidCollider } from '@react-three/rapier';

export const Borders = () => {
  const BORDER_SIZE = 75;
  const BORDER_HEIGHT = 20;
  const BORDER_THICKNESS = 1;

  return (
    <>
      {/* Left wall */}
      <CuboidCollider
        args={[BORDER_THICKNESS, BORDER_HEIGHT, BORDER_SIZE]}
        position={[-BORDER_SIZE, BORDER_HEIGHT / 2, 0]}
        restitution={0.5}
      />

      {/* Right wall */}
      <CuboidCollider
        args={[BORDER_THICKNESS, BORDER_HEIGHT, BORDER_SIZE]}
        position={[BORDER_SIZE, BORDER_HEIGHT / 2, 0]}
        restitution={0.5}
      />

      {/* Front wall */}
      <CuboidCollider
        args={[BORDER_SIZE, BORDER_HEIGHT, BORDER_THICKNESS]}
        position={[0, BORDER_HEIGHT / 2, BORDER_SIZE]}
        restitution={0.5}
      />

      {/* Back wall */}
      <CuboidCollider
        args={[BORDER_SIZE, BORDER_HEIGHT, BORDER_THICKNESS]}
        position={[0, BORDER_HEIGHT / 2, -BORDER_SIZE]}
        restitution={0.5}
      />

      {/* Ceiling */}
      <CuboidCollider
        args={[BORDER_SIZE, BORDER_THICKNESS, BORDER_SIZE]}
        position={[0, BORDER_HEIGHT, 0]}
        restitution={0.5}
      />
    </>
  );
};
